interface IgtmEvent {
	event: string;
}

declare global {
	interface Window {
		dataLayer: IgtmEvent[];
	}
}

const filterEmptyAttributes = ( obj: any ) =>
	Object.keys( obj )
		.map( ( k ) => [ k, obj[ k ] ] )
		.filter( ( [ k, v ] ) => v === 0 || !! v )
		.reduce( ( acc, [ k, v ] ) => ( { ...acc, [ k ]: v } ), {} );

export const trackGtmEvent = (
	event: string,
	payload = {},
	allowEmptyAttributes = false
) => {
	window.dataLayer = window.dataLayer || [];

	if ( allowEmptyAttributes ) {
		window.dataLayer.push( {
			...payload,
			event,
		} );
	} else {
		window.dataLayer.push( {
			...filterEmptyAttributes( payload ),
			event,
		} );
	}
};
